import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../../components/FormDialog';
import TextField from '@material-ui/core/TextField';

const initialValue = {
  tracking_number: ''
};

const InitialCaseCompletionDialog = ({ onContinue, open, initialValues, ...props }) => {
  const [data, setData] = useState(initialValue);

  const onChangeHandler = ({ target }) => {
    setData({
      ...data,
      [target.name]: target.value === '' ? null : target.value
    });
  };

  const closeHandler = response => {
    if (response && data.tracking_number) {
      onContinue(data);
    }

    if (!response) {
      setData(initialValue);
    }
  };

  useEffect(() => {
    setData({
      ...initialValue,
      ...initialValues
    });
  }, [initialValues]);

  return (
    <FormDialog
      titleText="Shipping Information"
      open={open}
      handleClose={closeHandler}
      acceptButtonText="Continue"
      {...props}
      isAcceptButtonDisabled={!data.tracking_number}
    >
      <TextField
        autoFocus
        id="name"
        name="tracking_number"
        label="Tracking Number"
        type="text"
        value={data.tracking_number}
        required
        onChange={onChangeHandler}
        fullWidth
      />
    </FormDialog>
  );
};

InitialCaseCompletionDialog.propTypes = {
  onContinue: PropTypes.func.isRequired,
  open: PropTypes.bool,
  initialValues: PropTypes.object
};

InitialCaseCompletionDialog.defaultProps = {
  open: false,
  initialValues: {}
};

export default InitialCaseCompletionDialog;
